var NavDrawerTemplate = function() {
    var createAnchorRow = function(text) {
        var row = $('<div></div>').addClass('row');
        var spanText = $('<span></span>').addClass('col-xs-11')
            .text(text);
        var arrow = $('<span></span>').addClass('col-xs-1')
            .addClass('p-a-0');
        var icon = $('<i></i>').addClass('icon-arrow-right5');
        arrow.append(icon);
        row.append(spanText);
        row.append(arrow);
        return row;
    };

    this.modelAnchor = function(submodel) {
        var anchor = $('<a></a>')
            .attr('data-model-nice-name', submodel.modelNiceName)
            .attr('data-model-nice-id', submodel.modelNiceId)
            .attr('data-model-name', submodel.modelName)
            .attr('data-submodel-nice-name', submodel.niceId)
            .attr('data-submodel-name', submodel.name);
        var row = createAnchorRow(submodel.name);
        anchor.append(row);
        return anchor;
    };

    this.linkOutAnchor = function(url, text) {
        var anchor = $('<a></a>')
            .attr('href', url);
        var row = createAnchorRow(text);
        anchor.append(row);
        return anchor;
    };

};

module.exports = new NavDrawerTemplate();


//////////////////
// WEBPACK FOOTER
// ./src/interlock/nav/drawer/template.js
// module id = 71
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14